const d3 = Object.assign({},
    require('d3-transition'),
    require('d3-selection'),
    require('d3-selection-multi'),
    require('d3-shape')
);

export class LinearBubbleRenderer {
    constructor ({
        chartDataHelper,
        chartRenderer,
        chartInteractions,
        scaler
    }) {
        this.chartDataHelper = chartDataHelper;
        this.chartRenderer = chartRenderer;
        this.interactions = chartInteractions;
        this.scaler = scaler;
        this.context = {
            margin: {
                left: 35, right: 5, top: 5, bottom: 40
            },
            palette: {
                fill: '#ff0000',
                stroke: '#444444'
            },
            r: {
                min: 5,
                max: 20
            }
        };
    }

    render (mode) {
        let yAxisLabel = this.chartDataHelper.settings.yAxis.label;
        let xAxisLabel = this.chartDataHelper.settings.xAxis.label;

        this.chartRenderer.addAxisLines(this.scaler.axis);
        this.chartRenderer.addAxisLabels(this.context, xAxisLabel, yAxisLabel);

        // use join to handle data changes
        // link: https://observablehq.com/@d3/selection-join

        // select the drawing area
        this.chartRenderer.getMainZone()
            // define a selection scope for data series
            .selectAll('.series')
            // bind a data array to this selection using series property as keys
            .data(this.chartDataHelper.dataSeries, d => d.series)
            // join => append entering elements, remove exiting elements, update current elements
            .join(
                // override enter command
                enter => enter.append('g').attr('class', 'series')
            )
            // iterate entering and updating elements
            // d (data): element data, i(index): element index, g(group): all D3 elements in the selection scope
            .each((d, i, g) => {
                // retrieve series id from data element
                const seriesId = d.series;
                // select currently iterated D3 element => element = group[index];
                d3.select(g[i])
                    // define selection scope for bubbles to render
                    .selectAll('circle')
                    // bind the metrics to the selection, using metric indexes as keys
                    .data(d => d.metric)
                    // join => append entering bubbles, remove exiting bubbles, update current bubbles
                    .join(
                        // override enter command
                        enter => enter
                            // create a bubble with initial properties
                            .append('circle')
                            .attr('fill', this.chartDataHelper.getSeriesColour(seriesId))
                            .attr('stroke', this.context.palette.stroke)
                            // create events for new elements
                            .on('mouseover', d => {
                                this.interactions.emitOverSeries({ seriesId, data: d, event });
                            })
                            .on('mouseout', d => {
                                this.interactions.emitOutSeries({ seriesId, data: d, event });
                            })
                            .on('click', d => {
                                this.interactions.emitClickSeries({ seriesId, data: d, event });
                            }),
                        // override update command (doing nothing in thiscase)
                        update => update,
                        // override exit command (doing nothing in this case)
                        exit => exit
                    )
                    // animate
                    .transition()
                    // set bubble positions for added and updated bubbles
                    .attr('cx', d => this.scaler.x(d[0]) + this.context.margin.left)
                    .attr('cy', d => this.scaler.y(d[1]) + this.context.margin.top)
                    .attr('r', d => this.scaler.z(d[2]));
            });
    }
}
